import { forwardRef } from 'react';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/shared/components/ui/input-otp';

interface MfaCodeInputProps {
  value: string;
  onChange: (code: string) => void;
  onComplete?: (code: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
}

export const MfaCodeInput = forwardRef<HTMLInputElement, MfaCodeInputProps>(
  ({ value, onChange, onComplete, disabled, autoFocus }, ref) => (
    <InputOTP
      ref={ref}
      maxLength={6}
      value={value}
      onChange={(v) => {
        onChange(v);
        if (v.length === 6) onComplete?.(v);
      }}
      disabled={disabled}
      autoFocus={autoFocus}
      inputMode="numeric"
      pattern="\d*"
    >
      <InputOTPGroup>
        <InputOTPSlot index={0} />
        <InputOTPSlot index={1} />
        <InputOTPSlot index={2} />
        <InputOTPSlot index={3} />
        <InputOTPSlot index={4} />
        <InputOTPSlot index={5} />
      </InputOTPGroup>
    </InputOTP>
  )
);

MfaCodeInput.displayName = 'MfaCodeInput';
